

export const isRestrictedMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTabletUA = /iPad|Tablet|PlayBook/i.test(userAgent) || (Boolean(navigator.maxTouchPoints) && navigator.maxTouchPoints > 1 && /Macintosh/i.test(userAgent)); // iPadOS 13+ pretends to be simplistic Mac

    if (isMobileUA && !isTabletUA) {
        return true;
    }


    const isTouch = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    if (isTouch) {

        const minDimension = Math.min(window.screen.width, window.screen.height);
        const maxDimension = Math.max(window.screen.width, window.screen.height);


        if (minDimension < 600) {
            return true; // Likely a phone
        }
    }

    return false;
};
